import React from "react";

/**
 * -Menu-
 * Menu component that acts as a homepage for both mobile and desktop
 **/
class HeaderMobileNav extends React.Component {
	render() {
		return (
			<div className="mobile-sub-menus">
				{ this.props.menus &&
					this.props.menus.map((item, i) => (
						<nav
							className={ `sub-menu-collection js-sub-menu-collection-mobile sub-menu-collection-mobile sub-menu-collection-mobile--${ i }` }
							data-sub-menu-item={ i }
							key={ i }
							aria-hidden="true"
						>
							<button
								className="menu-title js-sub-menu-close"
								type="button"
								data-sub-menu-select={ i }
							>
								<span className="assistive-text">
									Sub menu. Return to main menu.
								</span>
								<span className="back">
									<svg focusable="false" aria-hidden="true">
										<use xlinkHref="#arrow-small-down-w"></use>
									</svg>{ " " }
									back
								</span>
								{ item.text }
							</button>

							{ item.children !== null &&
								item.children.map((item, i) => (
									<SubMenu
										key={ i }
										subMenuText={ item.text }
										subMenuUrl={ item.url }
										subMenuChildren={ item.children }
									/>
								)) }
						</nav>
					)) }
			</div>
		);
	}
}

const SubMenu = ({ subMenuText, subMenuChildren }) => {
	const link = subMenuText === "Upcoming Events" ? "events" : "news";

	return (
		<div className="sub-menu-collection__child">
			<div id={ subMenuText + "NavLabel" } className="sub-nav-heading">
				{ subMenuText }
			</div>
			<ul aria-labelledby={ subMenuText + "NavLabel" }>
				{ subMenuChildren &&
					subMenuChildren.map((item, i) => (
						<SubMenuItem
							key={ i }
							text={ item.text }
							url={ item.url }
							children={ item.children }
						/>
					)) }

				{ (subMenuText === "Latest News" ||
					subMenuText === "Upcoming Events") && (
						<li>
							<a href={ `${ window.WEBSITE_ROOT }/${ link }/` }>
								<span>View all { link }</span>
							</a>
						</li>
					) }
			</ul>
		</div>
	);
};

const SubMenuItem = ({ text, url }) => {
	const linkContent = `${ text }
				<svg focusable="false" aria-hidden="true">
						<use xlink:href="#arrow-small-down-w"></use>
				</svg>`;

	return (
		<li>
			<a
				href={ url }
				className="js-sub-menu-link"
				dangerouslySetInnerHTML={ { __html: linkContent } }
			></a>
		</li>
	);
};

export default HeaderMobileNav;



// WEBPACK FOOTER //
// ./src/components/HeaderMobileNav.js